const UpcomingHeaders = [
  { id: 9, title: "Session #", labelKey: "sessionNumber" },
  { id: 1, title: "Meeting Link", labelKey: "meetingLink" },
  { id: 2, title: "Medium Name", labelKey: "mediumName" },
  { id: 7, title: "Session Name", labelKey: "sessionName" },
  // { id: 8, title: "Session Name" },
  { id: 3, title: "Date & Time", labelKey: "dateTime" },
  { id: 5, title: "Pay My Medium", labelKey: "payMyMedium" },
  { id: 6, title: "Cancel/Reschedule", labelKey: "cancelReschedule" },
  { id: 8, title: "Session Issues", labelKey: "sessionIssues" }
];

const completedHeaders = [
  { id: 9, title: "Session #", labelKey: "sessionNumber" },
  { id: 1, title: "Medium Name", labelKey: "mediumName" },
  { id: 7, title: "Session Type", labelKey: "sessionType" },
  { id: 8, title: "Session Name", labelKey: "sessionName" },
  { id: 2, title: "Date & Time", labelKey: "dateTime" },
  // { id: 4, title: "No Show" },
  { id: 6, title: "Complete Survey", labelKey: "completeSurvey" },
  { id: 5, title: "Pay Medium", labelKey: "payMedium" },
  { id: 8, title: "Session Issues", labelKey: "sessionIssues" },
  { id: 10, title: "Actions", labelKey: "actions" },
];
const CancelledHeaders = [
  { id: 6, title: "Session #", labelKey: "sessionNumber" },
  { id: 1, title: "Medium Name", labelKey: "mediumName" },
  { id: 5, title: "Session Type", labelKey: "sessionType" },
  { id: 2, title: "Date & Time", labelKey: "dateTime" },
  { id: 4, title: "Cancelled By", labelKey: "cancelledBy" },
  { id: 7, title: "Reason", labelKey: "reason" },
];
const NoShowsHeaders = [
  { id: 6, title: "Session #", labelKey: "sessionNumber" },
  { id: 1, title: "Medium Name", labelKey: "mediumName" },
  { id: 5, title: "Session Type", labelKey: "sessionType" },
  { id: 2, title: "Date & Time", labelKey: "dateTime" },
  { id: 4, title: "No show By", labelKey: "noShowBy" },
];
const list = [
  { id: 1, name: "Upcoming", labelKey: "upcoming", count: 0 },
  { id: 2, name: "Completed", labelKey: "completed", count: 0 },
  { id: 3, name: "Cancelled", labelKey: "cancelled", count: 0 },
  { id: 3, name: "No Shows", labelKey: "noShows", count: 0 },
];
export {
  UpcomingHeaders,
  list,
  completedHeaders,
  CancelledHeaders,
  NoShowsHeaders,
};
